import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { match, P } from "ts-pattern";

type ScoreStyles = {
  label: string;
  bgClass: string;
  borderClass: string;
  textClass: string;
  isMeaningful: boolean;
  tooltipText: string;
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export const getScoreStyles = (score?: number) =>
  match(score)
    .returnType<ScoreStyles>()
    .with(P.number.gte(0.7), () => ({
      label: "Meaningful",
      bgClass: "bg-green-50",
      borderClass: "border-green-200",
      textClass: "text-green-600",
      isMeaningful: true,
      tooltipText:
        "The alt-text accurately describes the product image in a way that is useful for low vision or blind customers. This helps them understand what the product looks like."
    }))
    .with(P.number.gte(0.4), () => ({
      label: "Partially meaningful",
      bgClass: "bg-yellow-50",
      borderClass: "border-yellow-200",
      textClass: "text-yellow-600",
      isMeaningful: true,
      tooltipText:
        "The alt-text provides some useful description but could be improved. Consider adding more details about the product's appearance, features, or context to make it more helpful."
    }))
    .with(P.number, () => ({
      label: "Not meaningful",
      bgClass: "bg-red-50",
      borderClass: "border-red-200",
      textClass: "text-red-600",
      isMeaningful: false,
      tooltipText:
        "This means the alt-text is the same as the product name and does not describe what is happening in the image, which is useful for low vision or blind customers."
    }))
    .otherwise(() => ({
      label: "Not analyzed",
      bgClass: "bg-gray-50",
      borderClass: "border-gray-200",
      textClass: "text-gray-600",
      isMeaningful: false,
      tooltipText: "Analysis for this image is not yet available. Please check back later."
    }));
